import { t } from 'i18next';
import { Document } from '../../@types/Search';
import { numberSeparator } from '../../utils/formats';
import { resolveBranchName } from '../../utils/resolver';
import { Cars } from '../Search/SearchModels';
import { getMarketCode } from '../../utils/market';

const slugify = (str: string) => {
  str = str.replace(/^\s+|\s+$/g, '');
  str = str.toLowerCase();

  const from = 'àáäåâèéëêìíïîòóöôšùúüûñç·/_,:;';
  const to = 'aaaaaeeeeiiiioooosuuuunc------';
  for (let i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  str = str
    .replace(/[^a-z0-9 -]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');

  return str;
};

const createItemUrl = (document: Document | Cars) => {
  const parts: string[] = [];

  if (document.title) {
    parts.push(document.title);
  }

  if (document.shortDescription) {
    parts.push(document.shortDescription);
  }

  if (document.gearboxType) {
    parts.push(document.gearboxType);
  }

  return slugify(parts.join('-'));
};

export const toProductCard = (document: Document | Cars, displayBranchName?: boolean) => ({
  id: document._id,
  title: document.title,
  image:
    document.featuredImage?.files?.[0].formats.find((x) => x.format === '770x514')?.url ||
    document?.featuredImage?.files?.[0]?.url,
  description: document.shortDescription,
  uspList: [
    {
      title: document.modelYear,
    },
    {
      title: `${numberSeparator(document.odometerReading?.value || document.mileage)} ${t(
        `odometer.${document.odometerReading?.unit || 'ScandinavianMile'}`
      )}`,
    },
    {
      title: document.gearboxType,
    },
    {
      title: document.fuelType,
    },
  ],
  price: `${numberSeparator(document.price)} kr`,
  deductibleVat:
    document.deductibleVat && getMarketCode() !== 'NO'
      ? `${numberSeparator(document.price * 0.8)} kr`
      : undefined,
  leasingPrice:
    document.leasingPrice !== undefined
      ? `${numberSeparator(document.leasingPrice)} kr/mån`
      : undefined,

  oldPrice:
    document.oldPrice !== undefined && document.price < document.oldPrice
      ? `${numberSeparator(document.oldPrice)} kr`
      : undefined,
  branchName: displayBranchName ? resolveBranchName(document.branches?.[0]?.name) : undefined,
  slug: createItemUrl(document),
});
